import React, { useMemo } from "react";
import st from './CropsFilterList.module.scss';
import { SelectorCropTNode } from "../../../../../store/reducers/dashboard/crops/selector/types";
import { CheckBox2, Type as T } from "@infobis/ui-styles-utils";
import { isEmpty, size } from "lodash";

type CropsFilterListProps = {
	data: SelectorCropTNode[]
	selected: SelectorCropTNode[]
	onClick: (node: SelectorCropTNode, isSelected: boolean) => void
	searchValue: string
	selectAll: (mode: 'select' | 'deselect') => void
}

const CropsFilterList = (props: CropsFilterListProps) => {
	const { data, onClick, selected, searchValue, selectAll } = props;
	const isSelected = (node: SelectorCropTNode) => Boolean(selected.find(selectedNode => selectedNode.id === node.id))

	const filteredNodes = useMemo(() => {
		return data.filter(node => node.name.toLowerCase().includes(searchValue.toLowerCase()))
	}, [data, searchValue])

	const renderList = () => {
		const allPicked = size(filteredNodes.filter(isSelected)) === size(filteredNodes)

		const handleAllClick = () => {
			selectAll(allPicked ? 'deselect' : 'select')
		}

		return [
			<CheckBox2 label={'Все'}
					   size={T.Sizes.M}
					   onChange={handleAllClick}
					   key={'crops-filter-list-all'}
					   style={{ paddingBottom: 3.5 }}
					   indeterminate
					   checked={allPicked} />,
			...filteredNodes.map(node => {
				const selected = isSelected(node)

				return <CheckBox2 label={node.name}
								  size={T.Sizes.M}
								  onChange={() => onClick(node, !selected)}
								  key={node.id}
								  checked={selected} />
			})
		]
	}

	return (
		<div className={st['crops__list']}>
			{isEmpty(filteredNodes)
				? <span className={st['crops__list-empty']}>Ничего не найдено</span>
				: renderList()
			}
		</div>
	)
}

export default CropsFilterList